export const SOLUTIONMAPPINGCONFIGSOURCE = [
  { value: 'Universal_Edge', label: 'Universal Edge' },
];

export const SOLUTIONMAPPINGCONFIGDESTINATION = [
  { value: 'Omniverse', label: 'Omniverse' },
];

export const chartTypeOptions = [
  { value: 'line', label: 'Line Chart' },
  { value: 'bar', label: 'Bar Chart' },
  { value: 'area', label: 'Area Chart' },
  { value: 'pie', label: 'Pie Chart' },
  { value: 'scatter', label: 'Scatter Plot' },
  { value: 'radar', label: 'Radar Chart' },
  { value: 'table', label: 'Table' },
  { value: 'metric', label: 'Metric' },
];

export const dataSourceTypeOptions = [
  { value: 'apiInternal', label: 'Internal API' },
  { value: 'apiExternal', label: 'External API' },
  { value: 'adx', label: 'Azure Data Explorer' },
];

export const httpMethodOptions = [
  { value: 'GET', label: 'GET' },
  { value: 'POST', label: 'POST' },
  { value: 'PUT', label: 'PUT' },
  { value: 'PATCH', label: 'PATCH' },
];

export const defaultOptions = [
  { value: 'telemetries', label: 'telemetries' },
  { value: 'events', label: 'events' },
  { value: 'processedalarms', label: 'processedalarms' },
];
